module.exports = __webpack_public_path__ + "img/ape-constructor-search.ab266272.svg";